import React from 'react';
import { Bell, Search, Menu, Shield, Building2, User } from 'lucide-react';
import { useLocation } from 'react-router-dom';
interface TopBarProps {
  userRole: string | null;
}
export function TopBar({
  userRole
}: TopBarProps) {
  const location = useLocation();
  const getPageTitle = (pathname: string) => {
    if (pathname.includes('/super-admin')) return 'Platform Management';
    if (pathname.includes('/admin/users')) return 'User Management';
    if (pathname.includes('/onboarding')) return 'Organization Setup';
    switch (pathname) {
      case '/':
        return 'Dashboard';
      case '/booking':
        return 'Book Travel';
      case '/trips':
        return 'My Trips';
      case '/approvals':
        return 'Approvals';
      case '/budget':
        return 'Budget Management';
      case '/travelers':
        return 'Traveler Tracking';
      case '/reports':
        return 'Reports & Analytics';
      case '/settings':
        return 'Settings';
      default:
        return 'Dashboard';
    }
  };
  const getRoleBadge = () => {
    switch (userRole) {
      case 'super_admin':
        return <span className="ml-2 inline-flex items-center rounded-full bg-purple-100 px-2.5 py-0.5 text-xs font-medium text-purple-800" data-id="element-119">
            <Shield className="mr-1 h-3 w-3" data-id="element-120" /> Super Admin
          </span>;
      case 'tenant_admin':
        return <span className="ml-2 inline-flex items-center rounded-full bg-blue-100 px-2.5 py-0.5 text-xs font-medium text-blue-800" data-id="element-121">
            <Building2 className="mr-1 h-3 w-3" data-id="element-122" /> Admin
          </span>;
      case 'manager':
        return <span className="ml-2 inline-flex items-center rounded-full bg-emerald-100 px-2.5 py-0.5 text-xs font-medium text-emerald-800" data-id="element-123">
            <User className="mr-1 h-3 w-3" data-id="element-124" /> Manager
          </span>;
      default:
        return null;
    }
  };
  return <header className="fixed top-0 right-0 z-30 ml-64 flex h-16 w-[calc(100%-16rem)] items-center justify-between border-b border-slate-200 bg-white px-6 shadow-sm" data-id="element-125">
      <div className="flex items-center gap-4" data-id="element-126">
        <button className="lg:hidden p-1 text-slate-500 hover:text-slate-700" data-id="element-127">
          <Menu className="h-6 w-6" data-id="element-128" />
        </button>
        <div data-id="element-129">
          <h1 className="text-xl font-semibold text-slate-800" data-id="element-130">
            {getPageTitle(location.pathname)}
          </h1>
        </div>
      </div>

      <div className="flex items-center gap-4" data-id="element-131">
        <div className="relative hidden md:block" data-id="element-132">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-133" />
          <input type="text" placeholder="Search..." className="h-10 w-64 rounded-lg border border-slate-300 bg-slate-50 pl-10 pr-4 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-134" />
        </div>

        <button className="relative rounded-full p-2 text-slate-500 hover:bg-slate-100 hover:text-slate-700" data-id="element-135">
          <Bell className="h-5 w-5" data-id="element-136" />
          <span className="absolute right-1.5 top-1.5 h-2 w-2 rounded-full bg-red-500 ring-2 ring-white" data-id="element-137"></span>
        </button>

        <div className="h-8 w-px bg-slate-200 mx-1" data-id="element-138"></div>

        <div className="flex items-center gap-2" data-id="element-139">
          <div className="flex flex-col items-end" data-id="element-140">
            <span className="text-sm font-medium text-slate-700 hidden sm:block" data-id="element-141">
              Acme Corp
            </span>
          </div>
          {getRoleBadge()}
          <div className="h-8 w-8 rounded bg-blue-100 flex items-center justify-center text-blue-700 font-bold text-xs ml-2" data-id="element-142">
            AC
          </div>
        </div>
      </div>
    </header>;
}